import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { MapService } from '@services/map.service';
import Query from '@arcgis/core/rest/support/Query';
import { executeQueryJSON } from '@arcgis/core/rest/query';
import { PlanparcelDataService } from '@services/planparcel-data.service';
import FeatureLayer from '@arcgis/core/layers/FeatureLayer';
// import { applyEdits } from '@arcgis/core/rest/featureLayer';
@Component({
    selector: 'app-parcel-edit',
    templateUrl: './parcel-edit.component.html',
    styleUrl: './parcel-edit.component.scss'
})
export class ParcelEditComponent implements OnInit {
    objectid: number;
    baladeyaNameOptions: string[] = [];
    neighNameOptions: string[] = [];
    planNameOptions: string[] = [];
    parcelNoOptions: string[] = [];
    baladeyaGeom = {};
    neighGeom = {};
    planGeom = {};
    parcelGeom = {};
    baladeyaName: string;
    planName: string;
    parcelNo: string;
    northBorder: string = '';
    southBorder: string = '';
    eastBorder: string = '';
    westBorder: string = '';
    northLength: string = '';
    southLength: string = '';
    eastLength: string = '';
    westLength: string = '';
    breaksLength: string = '';
    parcelFeature: any;

    constructor(
        private http: HttpClient,
        private mapService: MapService,
        private planparcel: PlanparcelDataService
    ) { }

    ngOnInit() {
        this.queryBaladeyaNames();
    }

    queryBaladeyaNames() {
        //   debugger;
        const queryUrl =
            'https://144.76.146.59:6443/arcgis/rest/services/Amana/AmanaFinal/FeatureServer/8/query?f=pjson&where=1%3D1&returnGeometry=false&outFields=BELEDIYE';
        const queryObject = new Query({
            where: '1=1',
            returnGeometry: false,
            outFields: ['BELEDIYE']
        });

        executeQueryJSON(queryUrl, queryObject).then((results) => {
            this.baladeyaNameOptions = results.features.map(
                (feature) => feature.attributes.BELEDIYE
            );
        });
    }

    queryNeighNames(baladeya: string) {
        const queryUrl =
            'https://144.76.146.59:6443/arcgis/rest/services/Amana/AmanaFinal/FeatureServer/5/query?f=pjson&where=1%3D1&returnGeometry=false&outFields=NEIGH_NAME';
        const queryObject = new Query({
            where: `BELEDIYE = N'${baladeya}'`,
            returnGeometry: false,
            outFields: ['NEIGH_NAME']
        });

        executeQueryJSON(queryUrl, queryObject).then((results) => {
            this.neighNameOptions = results.features.map(
                (feature) => feature.attributes.NEIGH_NAME
            );
        });
    }

    queryPlanNames(neigh: string) {
        const queryUrl =
            'https://144.76.146.59:6443/arcgis/rest/services/Amana/AmanaFinal/FeatureServer/5/query?f=pjson&where=1%3D1&returnGeometry=false&outFields=SUBDIVISIONNAME_AR';
        const queryObject = new Query({
            where: `Neigh_region = N'${neigh}'`,
            returnGeometry: false,
            outFields: ['SUBDIVISIONNAME_AR']
        });

        executeQueryJSON(queryUrl, queryObject).then((results) => {
            this.planNameOptions = results.features.map(
                (feature) => feature.attributes.SUBDIVISIONNAME_AR
            );
        });
    }

    queryParcelNo(planNme: string) {
        // SUBDIVISIONPLAN_ID
        const queryUrl =
            'https://144.76.146.59:6443/arcgis/rest/services/Amana/AmanaFinal/FeatureServer/2/query?f=pjson&where=1%3D1&returnGeometry=true&outFields=PARCEL_ID';
        const queryObject = new Query({
            where: `SUBDIVISIONPLANNAME_AR = N'${planNme}'`,
            returnGeometry: true,
            outFields: ['PARCEL_ID']
        });

        executeQueryJSON(queryUrl, queryObject).then((results) => {
            this.parcelNoOptions = results.features.map(
                (feature) => feature.attributes.PARCEL_ID
            );
            results.features.forEach((feature) => {
                this.parcelGeom[feature.attributes.PARCEL_ID] =
                    feature.geometry;
                // this.parceObjectlID[feature.attributes.PARCEL_ID]=feature.attributes.OBJECTID;
            });
        });
    }

    queryParcelDetails(parcelNo: string) {
        const queryUrl =
            'https://144.76.146.59:6443/arcgis/rest/services/Amana/AmanaFinal/FeatureServer/2/query?f=pjson&where=1%3D1&returnGeometry=false&outFields=SUBDIVISIONPLANNAME_AR,PARCEL_ID,NORTH_BOARDER,SOUTH_BOARDER,EAST_BOARDER,WEST_BOARDER,NORTH_LENGTH,SOUTH_LENGTH,EAST_LENGTH,WEST_LENGTH,BREAKS_LENGTH';
        const queryObject = new Query({
            where: `PARCEL_ID = N'${parcelNo}'`,
            returnGeometry: false,
            outFields: [
                'objectid',
                'NORTH_BOARDER',
                'SOUTH_BOARDER',
                'EAST_BOARDER',
                'WEST_BOARDER',
                'NORTH_LENGTH',
                'SOUTH_LENGTH',
                'EAST_LENGTH',
                'WEST_LENGTH',
                'BREAKS_LENGTH'
            ]
        });

        executeQueryJSON(queryUrl, queryObject).then((results) => {
            if (results.features.length > 0) {
                this.parcelFeature = results.features[0];
                this.objectid = this.parcelFeature.attributes.OBJECTID;
                this.northBorder = this.parcelFeature.attributes.NORTH_BOARDER;
                this.southBorder = this.parcelFeature.attributes.SOUTH_BOARDER;
                this.eastBorder = this.parcelFeature.attributes.EAST_BOARDER;
                this.westBorder = this.parcelFeature.attributes.WEST_BOARDER;
                this.northLength = this.parcelFeature.attributes.NORTH_LENGTH;
                this.southLength = this.parcelFeature.attributes.SOUTH_LENGTH;
                this.eastLength = this.parcelFeature.attributes.EAST_LENGTH;
                this.westLength = this.parcelFeature.attributes.WEST_LENGTH;
                this.breaksLength = this.parcelFeature.attributes.BREAKS_LENGTH;
            }
        });
    }

    onBaladeyaNameChange(event: any) {
        // debugger;
        const selectedBaladeya = event.target.value;
        console.log(event.target);
        this.queryNeighNames(selectedBaladeya);
        // this.mapService.mapView.goTo(this.baladeyaGeom[selectedBaladeya].extent);
    }
    onNeighNameChange(event: any) {
        const selectedNeigh = event.target.value;
        this.queryPlanNames(selectedNeigh);
    }
    onPlanNameChange(event: any) {
        const selectedPlan = event.target.value;
        this.queryParcelNo(selectedPlan);
    }
    onParcelNoChange(event: any) {
        const selectedParcelNo = event.target.value;
        this.queryParcelDetails(selectedParcelNo);
        this.mapService.mapView.goTo(this.parcelGeom[selectedParcelNo].extent);
    }

    //   saveParcelEdits() {
    //    // Prepare the edit operation
    //    const edits = [
    //      {
    //        operation: "update",
    //        features: [{
    //          attributes: {
    //            OBJECTID: this.objectid, // Assuming OBJECTID is the unique identifier for the parcel
    //            NORTH_BOARDER: this.northBorder,
    //            SOUTH_BOARDER: this.southBorder,
    //            EAST_BOARDER: this.eastBorder,
    //            WEST_BOARDER: this.westBorder,
    //            NORTH_LENGTH: this.northLength,
    //            SOUTH_LENGTH: this.southLength,
    //            EAST_LENGTH: this.eastLength,
    //            WEST_LENGTH: this.westLength,
    //            BREAKS_LENGTH: this.breaksLength
    //          }
    //        }],
    //        globalIdUsed:false,
    //        rollbackOnFailureEnabled: false
    //      }
    //    ];
    // debugger;
    //    // Apply the edits
    //    const updateURL = "https://144.76.146.59:6443/arcgis/rest/services/Amana/AmanaFinal/FeatureServer/2/applyEdits";
    //    this.http.post(updateURL, edits).subscribe(response => {

    //      console.log('Edits applied successfully', response);
    //    }
    //    // , error => {
    //    //   console.error('Failed to apply edits', error);
    //    // }
    // );
    //  }

    saveParcelEdits() {
        this.parcelFeature.attributes.OBJECTID = this.objectid;
        this.parcelFeature.attributes.NORTH_BOARDER = this.northBorder;
        this.parcelFeature.attributes.SOUTH_BOARDER = this.southBorder;
        this.parcelFeature.attributes.EAST_BOARDER = this.eastBorder;
        this.parcelFeature.attributes.WEST_BOARDER = this.westBorder;
        this.parcelFeature.attributes.NORTH_LENGTH = this.northLength;
        this.parcelFeature.attributes.SOUTH_LENGTH = this.southLength;
        this.parcelFeature.attributes.EAST_LENGTH = this.eastLength;
        this.parcelFeature.attributes.WEST_LENGTH = this.westLength;
        this.parcelFeature.attributes.BREAKS_LENGTH = this.breaksLength;

        const flyr = new FeatureLayer({
            url: 'https://144.76.146.59:6443/arcgis/rest/services/Amana/AmanaFinal/FeatureServer/2'
        });
        // url: 'https://144.76.146.59:6443/arcgis/rest/services/AmanaFinalTestt/AmanaFinalTestt/FeatureServer/3'});

        const requestBody = {
            updateFeatures: [this.parcelFeature]
        };

        const options = {
            // globalIdUsed has to be true when adding, updating or deleting attachments
            globalIdUsed: false,
            rollbackOnFailureEnabled: false
        };

        flyr.applyEdits(requestBody, options)
            .then((editsResult) => {
                if (editsResult.updateFeatureResults.length > 0) {
                    const objectId =
                        editsResult.updateFeatureResults[0].objectId;
                    console.log(editsResult);
                }
            })
            .catch((err) => {
                console.log('===============================================');
                console.error(
                    '[ applyEdits ] FAILURE: ',
                    err.code,
                    err.name,
                    err.message
                );
                console.log('error = ', err);
            });
    }

    //   saveEdits(){

    //    var parcelForm:FormData = new FormData();

    //    parcelForm.append('Id', this.objectid +'');
    //    parcelForm.append('northBorder',this.northBorder);
    //    parcelForm.append('southBorder',this.southBorder);
    //    parcelForm.append('eastBorder',this.eastBorder);
    //    parcelForm.append('westBorder',this.westBorder);
    //    parcelForm.append('northLength',this.northLength);
    //    parcelForm.append('southLength',this.southLength);
    //    parcelForm.append('eastLength',this.eastLength);
    //    parcelForm.append('westLength',this.westLength);
    //    parcelForm.append('breaksLength',this.breaksLength);

    //    this.planparcel.saveParcelBounds(parcelForm).subscribe((res)=>{

    //    })
    //   }
}
